import { AddPopoutSource } from 'owa-popout-v2';
import popoutCalendarReadingPane from 'owa-popout-utils/lib/utils/popoutCalendarReadingPane';

export function displayAppointmentForm(itemId: string) {
    popoutCalendarReadingPane(itemId, AddPopoutSource.Addins);
}
